{
  "fr": {
    "todo_list": {
      "actions": {
        "add": "Ajouter Liste de Tâches",
        "cancel": "Annuler",
        "delete_todo_list": "Supprimer liste de tâches",
        "edit": "Modifier",
        "new": "Liste de Tâches",
        "save": "Enregistrer",
        "title": "Titre"
      },
      "attributes": {
        "name": "Titre"
      },
      "labels": {
        "assignToLevel": "Attribuer au niveau",
        "createdAt": "Créé à",
        "filter_employee": "Responsable",
        "newTodoList": "Nouvelle liste de tâches",
        "sort": {
          "created_at_asc": "Le plus ancien en premier",
          "created_at_desc": "Le plus récent d'abord",
          "name_lower_asc": "Titre A -> Z",
          "name_lower_desc": "Titre Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Gardez un aperçu de ce que vous et votre équipe devez faire.",
            "title": "Ouvrir une nouvelle Liste de Tâches"
          }
        }
      },
      "toasts": {
        "create": "Liste de Tâches créée",
        "delete": "Liste de Tâches supprimée",
        "update": "Liste de Tâches mise à jour"
      },
      "validation": {
        "needTitle": "Titre requis"
      }
    }
  }
}